export const getLoginToken = () => {
    var token = localStorage.getItem('token');
    
    return token;
}

export const getSelectedProject = () => {
    
    let session_devil_project = sessionStorage.getItem('devil_project');
    if(session_devil_project)
        return parseInt(session_devil_project);
    var devil_project = localStorage.getItem('devil_project');
    if(!devil_project){
        devil_project = getCookie('devil_project');
        if(devil_project){
            localStorage.setItem('devil_project', devil_project);
        }
    }

    return parseInt(devil_project);
}


export const getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}